const ProjectHome = () =>
    import("../views/projectHome/index.vue"); // 新版项目主页
const BriefList = () =>
    import("../views/projectHome/brief-list.vue"); // 项目简报列表
const BriefPreview = () =>
    import("../views/projectHome/brief-preview.vue"); // 项目简报 PDF 预览
const NoticeList = () =>
    import("../views/projectHome/notice-list.vue"); // 通知公告列表
const NoticeDetail = () =>
    import("../views/projectHome/notice-detail.vue"); // 通知公告详情
const ScheduleList = () =>
    import("../views/projectHome/schedule-list.vue"); // 空间课表列表
const SpaceStatsList = () =>
    import("../views/projectHome/space-stats-list.vue"); // 结对空间统计列表
const CoursesList = () =>
    import("../views/projectHome/courses-list.vue"); // 精彩课堂列表
const ClassStatsList = () =>
    import("../views/projectHome/class-stats-list.vue"); // 结对班级统计列表
const ShowcaseList = () =>
    import("../views/projectHome/showcase-list.vue"); // 风采展示列表

export default [
    {
        path: "/projectHome/:id",
        name: "projectHome",
        component: ProjectHome,
        meta: {
            title: "项目主页",
            keepAlive: false
        }
    },
    {
        path: "/projectHome/:id/brief",
        name: "projectHomeBrief",
        component: BriefList,
        meta: {
            title: "项目简报",
            keepAlive: false
        }
    },
    {
        path: "/projectHome/:id/brief/preview",
        name: "projectHomeBriefPreview",
        component: BriefPreview,
        meta: {
            title: "周报预览",
            keepAlive: false
        }
    },
    {
        path: "/projectHome/:id/notice",
        name: "projectHomeNotice",
        component: NoticeList,
        meta: {
            title: "通知公告",
            keepAlive: false
        }
    },
    {
        path: "/projectHome/:id/notice/:noticeId",
        name: "projectHomeNoticeDetail",
        component: NoticeDetail,
        meta: {
            title: "公告详情",
            keepAlive: false
        }
    },
    {
        path: "/projectHome/:id/schedule",
        name: "projectHomeSchedule",
        component: ScheduleList,
        meta: {
            title: "空间课表",
            keepAlive: false
        }
    },
    {
        path: "/projectHome/:id/space-stats",
        name: "projectHomeSpaceStats",
        component: SpaceStatsList,
        meta: {
            title: "结对空间统计",
            keepAlive: false
        }
    },
    {
        path: "/projectHome/:id/courses",
        name: "projectHomeCourses",
        component: CoursesList,
        meta: {
            title: "精彩课堂",
            keepAlive: false
        }
    },
    {
        path: "/projectHome/:id/class-stats",
        name: "projectHomeClassStats",
        component: ClassStatsList,
        meta: {
            title: "结对班级统计",
            keepAlive: false
        }
    },
    {
        path: "/projectHome/:id/showcase",
        name: "projectHomeShowcase",
        component: ShowcaseList,
        meta: {
            title: "风采展示",
            keepAlive: false
        }
    }
]
